<div class="modal opened">
      <div class="modal-record-main">
        <div>
          <ng-container [ngSwitch]="status">
            <!-- here the two selectord for configure the record options -->
            <ng-template [ngSwitchCase]="STATUS_DEVICES_READY">
              <h2 class="head-custom" *ngIf="header != '' else title">{{header}}</h2>
              <ng-template #title>
                <h2 class="head-def">You are about to record a message for this approval.</h2>
              </ng-template>
              <p *ngIf="text != '' else subtitle" class="txt" [innerHTML]="text"></p>
              <ng-template #subtitle>
                <p class="txt" >You can stop the recording at any time with the Stop button at the top-right of your screen.</p>
              </ng-template>
              <div class="popup-box">
              <fieldset class="record-configuration">
                <ul>
                  <li class="image-source">
                    <figure></figure>
                  <core-helpers-forms-select
                    [label]="''"
                    [options]="videoSources"
                    (select)="onImageSourcesSelect($event)"
                  ></core-helpers-forms-select>
                  <!-- 
                  <ng-template #novideo>
                    <p class="no-video">No video input available.</p>
                  </ng-template> 
                  -->
                  </li>
                  <li class="audio-source">
                    <figure></figure>
                    <core-helpers-forms-select 
                      *ngIf="audioSources!=null && audioSources.length >0 else noaudio" 
                      [label]="''" 
                      [options]="audioSources"
                      (select)="onAudioSourcesSelect($event)"
                    ></core-helpers-forms-select>
                    <!-- TODO: set a message here. -->
                    <ng-template #noaudio>
                      <p class="no-audio" >No audio input available.<br /> Check your system config and browser permissions.</p>
                    </ng-template>
                  </li>
                </ul>
              </fieldset>
              </div>
              <fieldset [ngClass]="{'two-buttons': leftButtonText != ''}">
                <core-helpers-forms-button
                  [type]="'grey'"
                  [text]="leftButtonText"
                  (submit)="onLeftAction()"
                  [hidden]="leftButtonText == ''"
                ></core-helpers-forms-button>
                <core-helpers-forms-button-white 
                  [disabled]="disabled"
                  [text]="buttonText" 
                  (submit)="onAction()"
                ></core-helpers-forms-button-white>
              </fieldset>
              <p class="notice">** Please grant grant access to your camera and microphone so we can proceed.</p>
            </ng-template>
            <ng-template [ngSwitchCase]="STATUS_DEVICES_LOADING">
              <div class="popup-box popup-dimmed">
                <h2 class="head-custom" *ngIf="header != '' else title">{{header}}</h2>
                <ng-template #title>
                  <h2 class="head-def">You are about to record a message for this approval.</h2>
                </ng-template>
                  <p *ngIf="text != '' else subtitle" class="txt" [innerHTML]="text"></p>
                  <ng-template #subtitle>
                    <p class="txt">You can stop the recording at any time with the Stop button at the top-right of your screen.</p>
                  </ng-template>
                <div class="loader">
                  <div class="dimmed">
                    <div class="dimmed_content">
                      <div class="dimmed_flex_section">
                        <div class="dimmed_avatar"></div>
                        <div class="dimmed_info">
                          <div class="dimmed_subtitle"></div>
                        </div>
                      </div>
                      <div class="dimmed_flex_section">
                        <div class="dimmed_avatar"></div>
                        <div class="dimmed_info">
                          <div class="dimmed_subtitle"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template [ngSwitchCase]="STATUS_DEVICES_ERROR">
              <div class="popup-box popup-error">
                <core-helpers-box-alert-message-icon [text]="'There was an error getting the media devices.'"
                  [icon]="'alert'"></core-helpers-box-alert-message-icon>
                <p>It may not work because the camera, microphone, or both are disabled.</p>
                <fieldset>
                  <core-helpers-forms-button [type]="'grey'" [text]="leftButtonText" (submit)="onLeftAction()"
                    [hidden]="leftButtonText == ''"></core-helpers-forms-button>
                </fieldset>
              </div>
            </ng-template>
            <ng-template [ngSwitchCase]="STATUS_UNSUPPORTED_BROWSER">
              <div class="popup-box popup-error">
                <core-helpers-box-alert-message-icon [text]="'This feature is only supported in Chrome, Edge and Opera.'"
                  [icon]="'alert'"></core-helpers-box-alert-message-icon>
                <!-- <p>It may not work because the camera, microphone, or both are disabled.</p> -->
                <fieldset>
                  <core-helpers-forms-button [type]="'grey'" [text]="leftButtonText" (submit)="onLeftAction()"
                    [hidden]="leftButtonText == ''"></core-helpers-forms-button>
                </fieldset>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
</div>
